'use strict'

module.exports = ['$resource', function ($resource) {

    let Group = $resource('/groups/:id',
        {
            id: '@id'
        },
        {
            'save': { method: 'POST' },
            'update': { method: 'PATCH' }
        }
    )

    var save = Group.save

    // Required for "easy" .save in controllers
    Group.save = function (...args) {

        if (args[0].id) {
            this.update.apply(this, args)
        } else {
            save.apply(this, args)
        }
    }

    return Group
}]
